export default "__VITE_ASSET__BmdRj2QF__"